<template>
  <v-sheet color="deep-orange-lighten-4" v-if="$vuetify.display.mobile" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; backdrop-filter: blur(10px); z-index: 1015" class="d-flex justify-center align-center">
    <v-alert max-width="400" rounded="xl" color="deep-orange">
      <template v-slot:title>
        СООТНОШЕНИЕ СТОРОН ВАШЕГО МОНИТОРА НЕ ПОДДЕРЖИВАЕТСЯ ВАШИМ МОНИТОРОМ
      </template>
      <template v-slot:append>
        <v-chip density="compact" size="small">НЕ МЕНЕЕ</v-chip>
        <br>
        <v-sheet class="text-center" color="transparent">
          <v-icon :icon="['fas', '1']" />
          <v-icon :icon="['fas', '6']" />
          <v-icon :icon="['fas', 'x']" style="font-size: 10px !important;" class="mx-1" />
          <v-icon :icon="['fas', '9']" />
        </v-sheet>
        <br>
      </template>
      <v-btn v-on:click="go_home()" block density="compact" size="small" rounded="xl" variant="tonal">НА ГЛАВНУЮ</v-btn>
    </v-alert>
  </v-sheet>
</template>

<script>
export default {
  name: "NotMobile__WP_Alert",
  methods: {
    go_home: function () {
      this.$router.push({name: 'home'})
    }
  }
}
</script>

<style scoped>

</style>
